import React from 'react';
import clsx from 'clsx';
import InputBase from '@material-ui/core/InputBase';
import Box from '@material-ui/core/Box';
import { fade, makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius * 2,
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchDark: {
    backgroundColor: '#19314a',
    '&:hover': {
      backgroundColor: fade('#19314a', 0.25),
    },
  },
  searchLight: {
    backgroundColor: '#F5F6FA',
    '&:hover': {
      backgroundColor: fade('#F5F6FA', 0.25),
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6f809b'
  },
  inputRoot: {
    color: '#6f809b',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 200,
      '&:focus': {
        width: 200,
      },
    },
  },
}));

const Search = ({ theme }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
      <Box ml={5}>
          <div className={clsx(classes.search, theme? classes.searchDark: classes.searchLight)}>
              <div className={classes.searchIcon}>
                  <SearchIcon />
              </div>
              <InputBase
                  placeholder={formatMessage({id:"app.nav.search", defaultMessage:"Search a topic, pattern, …"})} 
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ 'aria-label': 'search' }}
              />
          </div>        
      </Box>
  );
}
export default Search;